import React from 'react';
import Dropdown from '../common/DropdownReact';

export default class AddConfigurationDropdown extends Dropdown {
    renderButton() {
        return (
            <div className="project-add-config-dropdown-button dropdown-button" onClick={this.onButtonClick}>
                <div className="dropdown-button-caret">
                    <svg width="12" height="12" viewBox="0 0 12 12">
                        <g>
                            <path strokeWidth="2" d="M0 6 L12 6 M6 0 L6 12 Z"/>
                        </g>
                    </svg>
                </div>
                <div className="dropdown-button-body">
                    {this.props.caption}
                </div>
            </div>
        )
    }
}